import React from 'react';
import styled from 'styled-components';

const Switch = ({ onChange }) => {
  return (
    <StyledWrapper>
      <label className="switch">
        <input type="checkbox" onChange={onChange} />
        <span className="slider" />
      </label>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  /* The switch - the box around the slider */
  .switch {
    font-size: 11px; /* Reduced font-size for scaling */
    position: relative;
    display: inline-block;
    width: 33px; /* Reduced width */
    height: 20px; /* Reduced height */
  }

  /* Hide default HTML checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  /* The slider */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    transition: .4s;
    border-radius: 24px; /* Adjusted for smaller size */
    border: 1px solid #ccc;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 1.5em; /* Reduced size */
    width: 1.5em; /* Reduced size */
    border-radius: 12px; /* Adjusted for smaller size */
    left: 1px; /* Adjusted for smaller size */
    top: 0;
    bottom: 0;
    background-color: white;
    box-shadow: 0 2px 5px #999999;
    transition: .4s;
  }

  input:checked + .slider {
    background-color: #5fdd54;
    border: 1px solid transparent;
  }

  input:checked + .slider:before {
    transform: translateX(1.2em); /* Adjusted for smaller width */
  }
`;

export default Switch;